export default {
  intro: {
    hero: {
      mobile: require('@/assets/videos/hero-mobile.mp4'),
      desktop: require('@/assets/videos/hero-desktop.mp4')
    },
    anekdote: require('@/assets/audio/helene_anekdote.mp3'),
    fader: {
      mobile: [
        require('@/assets/images/dalslider/helene.png'),
        require('@/assets/images/dalslider/ivo.png'),
        require('@/assets/images/dalslider/jimmy.png'),
        require('@/assets/images/dalslider/maayke.png'),
        require('@/assets/images/dalslider/reyhan.png'),
        require('@/assets/images/dalslider/tom.png')
      ],
      desktop: [
        require('@/assets/images/dalslider/helene@2x.png'),
        require('@/assets/images/dalslider/ivo@2x.png'),
        require('@/assets/images/dalslider/jimmy@2x.png'),
        require('@/assets/images/dalslider/maayke@2x.png'),
        require('@/assets/images/dalslider/reyhan@2x.png'),
        require('@/assets/images/dalslider/tom@2x.png')
      ]
    },
    poster: require('@/assets/images/posters/ink_hero.png')
  },
  chapter1: {
    rorschach: require('@/assets/videos/rorschach_jimmy.mp4'),
    anekdote: require('@/assets/audio/jimmy_anekdote.mp3'),
    poster: require('@/assets/images/posters/jimmy.png')
  },
  chapter2: {
    rorschach: require('@/assets/videos/rorschach_tom.mp4'),
    anekdote: require('@/assets/audio/tom_anekdote.mp3'),
    poster: require('@/assets/images/posters/tom.jpg')
  },
  chapter3: {
    rorschach: require('@/assets/videos/rorschach_reyhan.mp4'),
    anekdote: require('@/assets/audio/reyhan_anekdote.mp3'),
    poster: require('@/assets/images/posters/reyhan.png')
  },
  social: {
    instaNormal: {
      mobile: require('@/assets/images/social-simulation/insta-normal.png'),
      desktop: require('@/assets/images/social-simulation/insta-normal@2x.png')
    },
    instaDepressed: {
      mobile: require('@/assets/images/social-simulation/insta-depressed.png'),
      desktop: require('@/assets/images/social-simulation/insta-depressed@2x.png')
    },
    linkedInNormal: {
      mobile: require('@/assets/images/social-simulation/linkedin-normal.png'),
      desktop: require('@/assets/images/social-simulation/linkedin-normal@2x.png')
    },
    linkedInDepressed: {
      mobile: require('@/assets/images/social-simulation/linkedin-depressed.png'),
      desktop: require('@/assets/images/social-simulation/linkedin-depressed@2x.png')
    }
  },
  videoSwitch: {
    normal: {
      mobile: require('@/assets/videos/video_normal_small_480.mp4'),
      desktop: require('@/assets/videos/video_normal_small.mp4')
    },
    depressed: {
      mobile: require('@/assets/videos/video_depressed_small_480.mp4'),
      desktop: require('@/assets/videos/video_depressed_small.mp4')
    }
  },
  chapter4: {
    rorschach: require('@/assets/videos/rorschach_ivo.mp4'),
    rorschach2: require('@/assets/videos/rorschach_maayke.mp4'),
    anekdotes: {
      ivo: require('@/assets/audio/ivo_anekdote.mp3'),
      maayke: require('@/assets/audio/maayke_anekdote.mp3')
    },
    poster: require('@/assets/images/posters/ivo.png'),
    poster2: require('@/assets/images/posters/maayke.png')
  },
  chapter5: {
    rorschach: require('@/assets/videos/rorschach_helene.mp4'),
    anekdote: require('@/assets/audio/helene_anekdote.mp3'),
    poster: require('@/assets/images/posters/helene.jpg')
  },
  chapter6: {
    dalslider: {
      helene: {
        mobile: require('@/assets/images/dalslider/helene.png'),
        desktop: require('@/assets/images/dalslider/helene@2x.png'),
        background: require('@/assets/images/fader/helene.jpg'),
        audio: require('@/assets/audio/helene_dal.mp3')
      },
      ivo: {
        mobile: require('@/assets/images/dalslider/ivo.png'),
        desktop: require('@/assets/images/dalslider/ivo@2x.png'),
        background: require('@/assets/images/fader/ivo.jpg'),
        audio: require('@/assets/audio/ivo_dal.mp3')
      },
      jimmy: {
        mobile: require('@/assets/images/dalslider/jimmy.png'),
        desktop: require('@/assets/images/dalslider/jimmy@2x.png'),
        background: require('@/assets/images/fader/jimmy.jpg'),
        audio: require('@/assets/audio/jimmy_dal.mp3')
      },
      maayke: {
        mobile: require('@/assets/images/dalslider/maayke.png'),
        desktop: require('@/assets/images/dalslider/maayke@2x.png'),
        background: require('@/assets/images/fader/maayke.jpg'),
        audio: require('@/assets/audio/maayke_dal.mp3')
      },
      reyhan: {
        mobile: require('@/assets/images/dalslider/reyhan.png'),
        desktop: require('@/assets/images/dalslider/reyhan@2x.png'),
        background: require('@/assets/images/fader/reyhan.jpg'),
        audio: require('@/assets/audio/reyhan_dal.mp3')
      },
      tom: {
        mobile: require('@/assets/images/dalslider/tom.png'),
        desktop: require('@/assets/images/dalslider/tom@2x.png'),
        background: require('@/assets/images/fader/tom.jpg'),
        audio: require('@/assets/audio/tom_dal.mp3')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/media.js